{
  "app": {
    "name": "Woodcraft ERP",
    "tagline": "Project-based manufacturing, from quotation to installation.",
    "version": "Version {version}",
    "poweredBy": "Powered by {company}",
    "copyright": "© {year} {company}"
  },
  "auth": {
    "signIn": "Sign in",
    "signOut": "Sign out",
    "email": "Email",
    "password": "Password",
    "remember": "Keep me signed in",
    "forgot": "Forgot password?",
    "welcome": "Welcome back",
    "subtitle": "Sign in to your workspace",
    "invalid": "Invalid email or password",
    "locked": "Too many attempts. Try again in {minutes} minutes",
    "changePassword": "Change password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "passwordChanged": "Password changed. Please sign in again.",
    "switchCompany": "Switch company",
    "language": "Language",
    "profile": "My profile"
  },
  "common": {
    "save": "Save",
    "saveAndNew": "Save & new",
    "cancel": "Cancel",
    "close": "Close",
    "back": "Back",
    "new": "New",
    "create": "Create",
    "edit": "Edit",
    "delete": "Delete",
    "deactivate": "Deactivate",
    "reactivate": "Reactivate",
    "duplicate": "Duplicate",
    "search": "Search",
    "searchPlaceholder": "Search…",
    "filters": "Filters",
    "clearFilters": "Clear filters",
    "export": "Export",
    "import": "Import",
    "print": "Print",
    "refresh": "Refresh",
    "more": "More",
    "actions": "Actions",
    "viewAll": "View All",
    "viewDetails": "View Details",
    "details": "Details",
    "activity": "Activity",
    "documents": "Documents",
    "approvals": "Approvals",
    "notes": "Notes",
    "yes": "Yes",
    "no": "No",
    "none": "None",
    "all": "All",
    "today": "Today",
    "loading": "Loading…",
    "saving": "Saving…",
    "saved": "Saved",
    "required": "Required",
    "optional": "Optional",
    "reason": "Reason",
    "reasonPlaceholder": "Why is this change being made?",
    "comment": "Comment",
    "confirm": "Confirm",
    "areYouSure": "Are you sure?",
    "irreversible": "This action cannot be undone.",
    "copy": "Copy",
    "copied": "Copied",
    "select": "Select…",
    "noResults": "No results",
    "noData": "Nothing here yet",
    "createFirst": "Create the first {entity}",
    "showing": "Showing {from} to {to} of {total} records",
    "perPage": "{n} / page",
    "page": "Page {page} of {pages}",
    "sortBy": "Sort by",
    "columns": "Columns",
    "status": "Status",
    "createdAt": "Created",
    "createdBy": "Created by",
    "updatedAt": "Updated",
    "updatedBy": "Updated by",
    "vsLastMonth": "vs last month",
    "vsLastYear": "vs last year",
    "noChange": "No change",
    "of": "of",
    "from": "From",
    "to": "To",
    "date": "Date",
    "type": "Type",
    "reference": "Reference",
    "description": "Description",
    "user": "User",
    "amount": "Amount",
    "quantity": "Quantity",
    "total": "Total",
    "code": "Code",
    "name": "Name",
    "remove": "Remove"
  },
  "workflow": {
    "submit": "Submit for approval",
    "approve": "Approve",
    "reject": "Reject",
    "return": "Return",
    "decide": "Decision",
    "pending": "Pending approval",
    "approvedBy": "Approved by {name}",
    "rejectedBy": "Rejected by {name}",
    "step": "Step {n}: {label}",
    "awaiting": "Awaiting {role}",
    "changeRequest": "Change request",
    "changePending": "This change was sent for approval and will apply once approved.",
    "commentRequired": "A comment is required when rejecting or returning",
    "reasonRequired": "A reason is required",
    "inbox": "Approvals inbox",
    "nothingToApprove": "Nothing waiting for your approval",
    "requestedBy": "Requested by",
    "requestedAt": "Requested"
  },
  "errors": {
    "validation": "Please correct the highlighted fields",
    "forbidden": "You don't have permission to do this",
    "notFound": "Record not found",
    "conflict": "This conflicts with an existing record",
    "unknown": "Something went wrong. Please try again.",
    "network": "Cannot reach the server",
    "sessionExpired": "Your session has expired. Please sign in again.",
    "noAccessTitle": "This screen is not in your authorization matrix",
    "noAccessHint": "Ask your administrator to grant it (Administration → Authorization matrix)"
  },
  "audit": {
    "title": "Audit trail",
    "changed": "{user} changed {field} from {old} to {new}",
    "created": "{user} created this record",
    "deleted": "{user} deleted this record",
    "noChanges": "No changes recorded",
    "field": "Field",
    "old": "Old value",
    "new": "New value"
  },
  "home": {
    "welcome": "Welcome, {name}",
    "quickActions": "Quick Actions",
    "recentActivities": "Recent Activities",
    "upcomingTasks": "Upcoming Tasks",
    "pendingApprovals": "Pending Approvals",
    "kpi": {
      "activeProjects": "Active Projects",
      "salesYtd": "Sales (YTD)",
      "purchasesYtd": "Purchases (YTD)",
      "productionOutput": "Production Output",
      "pendingInvoices": "Pending Invoices",
      "employees": "Employees",
      "customers": "Customers",
      "suppliers": "Suppliers",
      "items": "Items"
    },
    "comingDay": "Available on build day {day}"
  },
  "nav": {
    "settings": "Settings",
    "help": "Help & Support",
    "notifications": "Notifications",
    "markAllRead": "Mark all as read",
    "noNotifications": "No notifications",
    "search": "Search (Customers, Projects, Items, Documents…)",
    "comingSoon": "This screen is planned for build day {day}",
    "setup": "Setup & master data",
    "plannedScope": "Planned scope",
    "home": "Home"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "support": "Support",
    "english": "English",
    "arabic": "Arabic",
    "egypt": "Egypt"
  },
  "admin": {
    "users": "Users",
    "roles": "Roles & Permissions",
    "addUser": "Add user",
    "inviteSent": "User created. Temporary password: {password}",
    "permissionMatrix": "Permission matrix",
    "organization": "Organization structure",
    "settings": "System settings",
    "numbering": "Document numbering",
    "auditLog": "Audit log",
    "systemInfo": "System information",
    "workflows": "Workflows",
    "integrations": "Integrations",
    "companyInfo": "Company information",
    "backup": "Backup data",
    "authorization": "Authorization matrix",
    "authorizationHint": "Which screens open, which reports run, which functions execute — per role, with per-user overrides and data scopes",
    "matrixRoles": "Roles",
    "matrixUsers": "Users",
    "kind_screen": "Screens",
    "kind_report": "Reports",
    "kind_function": "Functions",
    "allModules": "All modules",
    "everything": "Everything (*)",
    "everythingNeedsConfigure": "Granting everything needs the role-configure permission",
    "members": "members",
    "viaPattern": "granted through",
    "unsavedRoles": "{n} role(s) changed — save to apply",
    "matrixLegend": "A module row grants the whole module; shaded cells come from a wildcard",
    "owner": "Owner",
    "noRoles": "No roles",
    "ownerNote": "Tenant owners bypass the matrix: only a deny below applies to them",
    "pickUser": "Pick a user",
    "pickUserHint": "Choose a user on the left to see and change their effective access and data scopes",
    "dataScopes": "Data scopes",
    "dataScopesHint": "Confine the user to specific companies, branches, projects, warehouses or cost centres. Unrestricted means every record; a confined dimension shows only records that belong to the chosen ones (records with no value for it stay visible).",
    "unrestricted": "Unrestricted",
    "confinedTo": "confined to {n}",
    "saveScopes": "Save data scopes",
    "effectiveAccess": "Effective access",
    "effective": "Effective",
    "grantedVia": "Granted via",
    "override": "Override",
    "override_inherit": "Inherit from roles",
    "override_allow": "Allow",
    "override_deny": "Deny",
    "allowed": "Allowed",
    "refused": "Refused",
    "overrideHint": "A deny wins over every role grant; an allow adds to them",
    "saveOverrides": "Save overrides"
  },
  "ui": {
    "always": "Always",
    "attachPdf": "Attach PDF to record",
    "columns": "Columns",
    "computeKpis": "Compute KPIs now",
    "computeKpisHint": "KPIs are snapshotted daily by the scheduler; compute them now to see today's values.",
    "configure": "Configure",
    "connectors": "Connectors",
    "csvFile": "CSV file",
    "customise": "Customise",
    "customised": "Customised",
    "days": "days",
    "deactivatedRecord": "This record is deactivated. It stays for history and reports; reactivate it to use it again.",
    "enabled": "Enabled",
    "events": "Events",
    "eventsHint": "Every created record and workflow completion is published here once webhooks are enabled.",
    "failed": "failed",
    "jobTitle": "Job title",
    "keyField": "Match existing rows by",
    "keyFieldHint": "Rows whose key matches an existing record are updated instead of created.",
    "kpis": "Key performance indicators",
    "languageHint": "Screens, printed documents and e-mails follow your language.",
    "lastLogin": "Last sign-in",
    "nextValue": "Next number",
    "nextValueHint": "Leave empty to keep the current counter.",
    "numberingHint": "Prefix and pattern per document type. Placeholders:",
    "passwordMismatch": "The new passwords do not match",
    "passwordPolicy": "At least 10 characters with letters, numbers and a symbol.",
    "pattern": "Pattern",
    "pickRole": "Pick a role on the left to see and edit its permissions.",
    "prefix": "Prefix",
    "preview": "Preview",
    "projectProgress": "Project progress",
    "reports": "Reports",
    "requiresApproval": "Requires approval",
    "resetDefault": "Reset to shipped workflow",
    "resetDefaultHint": "The tenant configuration is deactivated and the shipped workflow applies again. Versions are kept in history.",
    "resetYearly": "Reset every year",
    "row": "Row",
    "rows": "rows",
    "runQuery": "Run query",
    "runReport": "Run report",
    "shareSecurely": "Share it with the user through a secure channel; it is shown only once.",
    "shipped": "Shipped",
    "shippedSteps": "shipped steps",
    "target": "Target",
    "template": "Template",
    "temporaryPassword": "Temporary password",
    "test": "Test",
    "timezone": "Time zone",
    "transitions": "transitions",
    "unmapped": "Unmapped columns",
    "validate": "Validate",
    "versions": "Versions",
    "wildcardGrants": "Wildcard grants",
    "workflowNoteHint": "Why this configuration exists (board decision, policy reference)…",
    "workflowsHint": "Approval matrices per document: who approves, thresholds, which actions are allowed.",
    "poweredBy": "Powered by {product}"
  },
  "brand": {
    "title": "Branding & White-label",
    "sub": "Your name, logo and colours on every screen and printed document of this account.",
    "identity": "Identity",
    "appName": "Application name",
    "appNameHint": "Shown in the sidebar, the browser tab and the login page — e.g. \"Grove ERP\".",
    "tagline": "Tagline (English)",
    "taglineAr": "Tagline (Arabic)",
    "poweredBy": "Powered-by line",
    "poweredByHint": "Shown in the footer and on printed documents. Switch it off to white-label completely.",
    "productName": "Product name",
    "logos": "Logos",
    "logo": "Logo",
    "logoHint": "Horizontal logo, SVG or PNG with transparent or white background (max 400 KB). Used in the sidebar, the login page and printed documents when a company has no logo of its own.",
    "mark": "Mark (square)",
    "markHint": "Small square version for the collapsed sidebar and the browser tab. Optional — the logo is used when empty.",
    "noLogo": "No image",
    "upload": "Upload image",
    "replace": "Replace",
    "tooLarge": "Image too large — the limit is {kb} KB.",
    "unsupported": "Use an SVG, PNG, JPEG or WebP image.",
    "colours": "Colours",
    "primary": "Primary",
    "primaryHint": "Buttons, links, active items, charts.",
    "accent": "Accent",
    "accentHint": "Highlights and markers.",
    "sidebar": "Sidebar",
    "sidebarHint": "Background of the navigation bar. Text colour adapts automatically.",
    "preview": "Preview",
    "previewHint": "What every user of this account will see after you save. Company logos on printed documents can also be set per company (Administration → Company Information).",
    "reset": "Reset to defaults",
    "saved": "Branding saved — applied to every screen and printed document.",
    "storedIssues": "Some stored values were invalid and replaced by defaults",
    "sampleModule": "CRM & Sales",
    "sampleModule2": "Procurement",
    "sampleKpi": "Revenue this month",
    "sampleDoc": "Quotation QT-2026-0001",
    "sampleFooter": "Printed by System Administrator"
  },
  "ai": {
    "assistant": "Assistant",
    "conversations": "Conversations",
    "newConversation": "New conversation",
    "noConversations": "No conversations yet",
    "intro": "Ask about anything in the system — records, figures, what needs attention — or ask me to prepare a record for you to confirm.",
    "thinking": "Thinking…",
    "placeholder": "Ask, or say what to prepare… (Enter to send)",
    "send": "Send",
    "lines": "line(s)",
    "openDraft": "Open the draft",
    "openScreen": "Open",
    "mockNote": "The mock provider is on: answers are placeholders until a model is configured (Administration → Integrations → AI assistant).",
    "starterSummarise": "Summarise this record",
    "starterNext": "What should happen next on this record?",
    "starterRisks": "Anything wrong or overdue here?",
    "starterOverdue": "Which customer invoices are overdue?",
    "starterStock": "Which items are below their reorder point?",
    "starterProjects": "Which projects are losing money?",
    "searchPlaceholder": "Search, or describe what you want to find…",
    "askSearch": "Ask AI to find: \"{text}\"",
    "menu": "AI",
    "summarise": "Summarise",
    "summary": "Summary",
    "askAbout": "Ask about this record",
    "draftEmail": "Draft an e-mail about this",
    "draftField": "Draft with AI",
    "translateTo": "Translate to {lang}",
    "insights": "Today's insights",
    "insightsEmpty": "Nothing needs attention right now.",
    "refresh": "Refresh",
    "generatedBy": "narrated by {model}",
    "applyLines": "Creating {n} line(s)…",
    "linesCreated": "{n} line(s) created",
    "extractLines": "Extract lines from text",
    "extractHint": "Paste a supplier quotation, a bill of quantities or any text with line items",
    "extractRun": "Extract",
    "extractResult": "{n} line(s) found",
    "addLines": "Add {n} line(s)",
    "copy": "Copy",
    "useText": "Use this text"
  },
  "trace": {
    "scan": "Scan",
    "title": "Scan & Trace",
    "intro": "Scan a label or tag with a scanner or the camera, or type a code — a receipt, lot, item, asset, inspection, employee badge…",
    "placeholder": "Scan or type a code (GRN-2026-0024, LOT-2026-00007, RW-001, AST-2026-0004…)",
    "resolve": "Look up",
    "camera": "Scan with camera",
    "stopCamera": "Stop camera",
    "cameraUnsupported": "This browser cannot read codes from the camera (Chrome on Android and recent Chromium can). Use a scanner or type the code.",
    "cameraDenied": "Camera access was refused or is unavailable.",
    "notFound": "No record carries the code {code} — or it is outside your rights.",
    "lineOf": "line of",
    "open": "Open",
    "actions": "Next steps",
    "facts": "Details",
    "trace": "Traceability",
    "origin": "Origin",
    "receipt": "Receipt",
    "supplier": "Supplier",
    "purchaseOrder": "Purchase order",
    "inspection": "Inspection",
    "balances": "Where it is now",
    "movements": "Movements",
    "noMovements": "No movements yet",
    "onHand": "On hand",
    "reserved": "Reserved",
    "warehouse": "Warehouse",
    "qty": "Qty",
    "document": "Document",
    "type": "Type",
    "date": "Date",
    "project": "Project",
    "workOrder": "Work order",
    "code": "Scan code",
    "printLabels": "Print labels",
    "labels": "Labels",
    "labelSize": "Label size",
    "size50": "Thermal 50 × 30 mm",
    "size100": "Thermal 100 × 50 mm",
    "sizeA4": "A4 sheet (2 × 6)",
    "scanHistory": "Scan history",
    "noScans": "Not scanned yet",
    "scannedBy": "{user} · {when}",
    "purpose": "Purpose",
    "recent": "Scanned in this session",
    "copyCode": "Copy code",
    "qrHint": "Point a phone camera at the QR to open this record on the scan screen",
    "unknownKind": "Unknown",
    "kind_document": "Document",
    "kind_line": "Line",
    "kind_lot": "Lot",
    "kind_item": "Item",
    "kind_asset": "Asset",
    "kind_person": "Employee"
  },
  "docs": {
    "recycleBin": "Recycle Bin",
    "recycleBinIntro": "Documents removed from their folders. Restoring puts a document back where it was, with its versions and links.",
    "binEmpty": "The recycle bin is empty",
    "binEmptyHint": "Documents moved to the recycle bin from their record page appear here.",
    "binHint": "Documents are removed from their own page (Move to Recycle Bin); approved documents need a document administrator. Back to",
    "restore": "Restore",
    "restored": "Document restored ✓",
    "number": "Document No.",
    "title": "Title",
    "category": "Category",
    "folder": "Folder",
    "version": "Version",
    "deletedAt": "Deleted",
    "deletedBy": "Deleted by"
  }
}
